import React, { AllHTMLAttributes } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
//import { Hooks } from "@xt/xtbase";
//import store from "store";
import styles from "./index.module.scss";
interface LoadingProps extends AllHTMLAttributes<HTMLElement> {
  attr?: any;
}
//const { useTranslation } = Hooks;
const Loading: React.FC<LoadingProps> = ({ className }) => {
  //const t = useTranslation();
  //const {isLogin} = store.user;
  return (
    <div className={cx(styles.TheLoading, className)}>
      <div></div>
    </div>
  );
};
export default observer(Loading);
